import React, { useContext } from "react";
import { Trans } from "react-i18next";
import { CustomI18nextContext } from "../../contexts/CustomI18nextContext";
import { INSTANCES } from "../../utils/featureFlag";
import SignUpButton from "../SignUpButton";
import Link from "../Link";
import CreateAccountImg from "../../assets/svgs/earn-referral-get-started-1.svg";
import DepositFundsImg from "../../assets/svgs/earn-referral-get-started-2.svg";
import TradeImg from "../../assets/svgs/earn-referral-get-started-3.svg";

const Partners = ({ partners }) => (
  <ul id="earn-referral-get-started__partners" className="mb-3 pl-3">
    {partners?.map((partner) => (
      <li>
        <span className="mb-0">{partner}</span>
      </li>
    ))}
  </ul>
);

const GetStarted = () => {
  const { t, siteCountry } = useContext(CustomI18nextContext);
  return (
    <div id="earn-referral-get-started">
      <div className="container">
        <div className="text-left text-md-center">
          <h3 className="text-blurple">
            {t("earnReferral.getStarted.subTitle")}
          </h3>
          <h2 className="text-black-main">
            {t("earnReferral.getStarted.title")}
          </h2>
        </div>
        <div>
          <ol className="vertical-timeline">
            <li className="vertical-timeline__list">
              <div className=" vertical-line" />
              <div className="grid-container">
                <div className="grid-col-12 grid-col-md-9 content-wrapper">
                  <h3>{t("earnReferral.getStarted.createAccount.title")}</h3>
                  <p>
                    {t("earnReferral.getStarted.createAccount.description")}
                  </p>
                  <SignUpButton className="button button-signup-lime px-5 mt-2">
                    {t("earnReferral.getStarted.createAccount.btnSignUp")}
                  </SignUpButton>
                </div>
                <CreateAccountImg className="d-none d-md-block grid-col-md-3 py-2 align-self-center" />
              </div>
            </li>
            <li className="vertical-timeline__list">
              <div className=" vertical-line" />
              <div className="grid-container content-wrapper">
                <div className="grid-col-12 grid-col-md-8">
                  <h3>{t("earnReferral.getStarted.depositFunds.title")}</h3>
                  <p>
                    <Trans
                      i18nKey="earnReferral.getStarted.depositFunds.description"
                      components={[
                        <Link
                          to={t(
                            "earnReferral.getStarted.depositFunds.descriptionLink"
                          )}
                        >
                          here
                        </Link>,
                      ]}
                    />
                  </p>

                  {siteCountry === INSTANCES.ID && (
                    <Partners
                      partners={t(
                        "earnReferral.getStarted.depositFunds.partners",
                        {
                          returnObjects: true,
                        }
                      )}
                    />
                  )}

                  {siteCountry === INSTANCES.TH && (
                    <small>
                      <Trans
                        i18nKey="earnReferral.getStarted.depositFunds.note"
                        components={[
                          <Link
                            to={t(
                              "earnReferral.getStarted.depositFunds.noteLink"
                            )}
                          >
                            here
                          </Link>,
                        ]}
                      />
                    </small>
                  )}
                </div>
                <DepositFundsImg className="d-none d-md-block grid-col-md-4" />

                {siteCountry === INSTANCES.ID && (
                  <div className="grid-col-12 grid-col-md-10">
                    <p>
                      <Trans
                        i18nKey="earnReferral.getStarted.depositFunds.hook"
                        components={[
                          <strong>
                            It takes less than 5 mins to deposit!
                          </strong>,
                          <br />,
                        ]}
                      />
                    </p>

                    <small>
                      <Trans
                        i18nKey="earnReferral.getStarted.depositFunds.note"
                        components={[
                          <Link
                            to={t(
                              "earnReferral.getStarted.depositFunds.noteLink"
                            )}
                          >
                            here
                          </Link>,
                        ]}
                      />
                    </small>
                    <br />

                    <small>
                      <Trans
                        i18nKey="earnReferral.getStarted.depositFunds.note2"
                        components={[
                          <Link
                            to={t(
                              "earnReferral.getStarted.depositFunds.note2Link"
                            )}
                          >
                            here
                          </Link>,
                        ]}
                      />
                    </small>
                  </div>
                )}
              </div>
            </li>
            <li className="vertical-timeline__list">
              <div className="grid-container">
                <div className="grid-col-12 grid-col-md-9 content-wrapper">
                  <h3>{t("earnReferral.getStarted.trade.title")}</h3>
                  <p>
                    <Trans
                      i18nKey="earnReferral.getStarted.trade.hook"
                      components={[
                        <Link to={`${t("common.exchangeLink")}/exchange`}>
                          our exchange
                        </Link>,
                      ]}
                    />
                  </p>
                  <p>
                    <Trans
                      i18nKey="earnReferral.getStarted.trade.description"
                      components={[
                        <strong>
                          We have over 60 cryptocurrencies available for trading
                        </strong>,
                        <br />,
                      ]}
                    />
                  </p>
                  <small>{t("earnReferral.getStarted.trade.note")}</small>
                </div>
                <TradeImg className="d-none d-md-block grid-col-md-3 align-self-center" />
              </div>
            </li>
          </ol>
        </div>
        <p id="earn-referral-get-started__that-simple" className="h3">
          {t("earnReferral.getStarted.thatSimple")}
        </p>
      </div>
    </div>
  );
};

export default GetStarted;
